import { Mail, Clock, Phone } from "lucide-react";
import { COMPANY } from "../data/mock";

export const ContactSection = () => {
  const cards = [
    {
      icon: Mail,
      title: "Email",
      line1: COMPANY.email,
      line2: COMPANY.emailSecondary,
      href: `mailto:${COMPANY.email}`,
    },
    {
      icon: Phone,
      title: "Phone",
      line1: COMPANY.phone,
      line2: "Call us anytime for immediate assistance",
      href: `tel:${COMPANY.phone}`,
    },
    {
      icon: Clock,
      title: "Hours",
      line1: `Dispatch: ${COMPANY.dispatchHours} | Office: ${COMPANY.officeHours}`,
      line2: "Emergency & after-hours dispatch available",
    },
  ];

  return (
    <section id="contact" className="py-20 lg:py-24 bg-[hsl(220,25%,97%)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-navy-900 mb-3">
            Get In <span className="text-hevi-red">Touch</span>
          </h2>
          <p className="text-slate-400 text-[16px]">We're ready when you are</p>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 lg:gap-6 max-w-4xl mx-auto">
          {cards.map((card, i) => {
            const Icon = card.icon;
            const Wrapper = card.href ? "a" : "div";
            const wrapperProps = card.href ? { href: card.href } : {};
            return (
              <Wrapper
                key={i}
                {...wrapperProps}
                className="group bg-white rounded-2xl p-7 border border-slate-200/60 card-premium hover:shadow-xl transition-all duration-500 block"
              >
                <div className="w-11 h-11 rounded-xl bg-navy-50 flex items-center justify-center mb-5 group-hover:bg-navy-100/80 transition-colors duration-300">
                  <Icon size={20} className="text-hevi-blue" />
                </div>
                <h3 className="text-[15px] font-bold text-navy-900 mb-2">{card.title}</h3>
                <p className="text-navy-700 font-medium text-[13px] mb-1">{card.line1}</p>
                <p className="text-slate-400 text-xs">{card.line2}</p>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};
